import * as React from 'react';

import { css, StyleSheet } from 'aphrodite';
import { Col, Container, Row } from 'reactstrap';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import newtheme from '../../newtheme';
import IconLandingRightArrow from '../../assets/icons/IconLandingRightArrow';
import { MpTrackingButtons } from '../../config/buttons';
import { openModal } from '../../actions/modal';
import IUser from '../../types/models/IUser';
import { IState } from '../../reducers';
import { mpTrackButtonClick } from '../../tracking/mixpanel';
import config from '../../config';
import ModalTypes from '../../types/ModalTypes';
import ISubscriptionProduct from '../../domaindriven/subscribe/types/ISubscriptionProduct';
import { getSelectedSubscriptionProduct } from '../../domaindriven/subscribe/state/selectors';
import { ILandingPageSignupBlock1 } from '../../domaindriven/landing/types/ILandingPageSignupBlock1';

interface IPropsFromState {
    user?: IUser;
    subscriptionProduct?: ISubscriptionProduct;
}

interface IPropsFromDispatch {
    openModal: typeof openModal;
}

interface IProps {
    sectionData: ILandingPageSignupBlock1;
}

class StartListeningBanner extends React.Component<
    IPropsFromState & IPropsFromDispatch & RouteComponentProps & IProps
> {
    public onButtonClicked = () => {
        const { subscriptionProduct } = this.props;

        if (subscriptionProduct && subscriptionProduct.metadata.homePage.redirectToPage) {
            if (this.props.user || !subscriptionProduct.metadata.homePage.showSignup) {
                this.props.history.push(subscriptionProduct.metadata.homePage.redirectToPage);
                return;
            }

            this.showSignup();
            return;
        }

        if (this.props.user) {
            this.props.history.push(config.routes.homeWebPlayer);
            return;
        }

        this.showSignup();
    };

    public showSignup = () => {
        mpTrackButtonClick(MpTrackingButtons.SHOW_SIGNUP_USE_CASES);

        this.props.openModal(ModalTypes.SignUpNew);
    };

    public render() {
        const { sectionData } = this.props;
        return (
            <div className={css(styles.main)}>
                <div className={css(styles.background)}>
                    <Container className={css(styles.container)}>
                        <Row className={css(styles.center)}>
                            <Col md={7} lg={8} className={css(styles.center)}>
                                <h3 className={css(styles.heading)}>{sectionData.title}</h3>
                            </Col>
                            <Col md={5} lg={4} className={css(styles.center)}>
                                <button type="button" className={css(styles.mainButton)} onClick={this.onButtonClicked}>
                                    {this.props.subscriptionProduct &&
                                    this.props.subscriptionProduct.metadata.homePage.buttonText
                                        ? this.props.subscriptionProduct.metadata.homePage.buttonText
                                        : 'Start Listening'}{' '}
                                    <IconLandingRightArrow className={css(styles.arrowIcon)} />
                                </button>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        );
    }
}

const styles = StyleSheet.create({
    main: {
        [newtheme.cssBreakpoints.tiny]: {
            paddingBottom: 50,
        },
        backgroundColor: 'white',
        paddingBottom: 80,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        width: '100%',
    },
    background: {
        [newtheme.cssBreakpoints.largeWidthLargeHeight]: {
            width: 900,
        },
        [newtheme.cssBreakpoints.tiny]: {
            borderRadius: 20,
        },
        background: 'linear-gradient(95.01deg, #2E547A 0%, rgba(46, 84, 122, 0) 68.62%), #031629',
        borderRadius: 30,
        width: '100%',
        margin: '0 2%',
        maxWidth: 1400,
    },
    container: {
        [newtheme.cssBreakpoints.large]: {
            padding: '70px 50px',
        },
        [newtheme.cssBreakpoints.medium]: {
            padding: 50,
        },
        [newtheme.cssBreakpoints.small]: {
            padding: 30,
        },
        padding: '85px 50px',
    },
    center: {
        [newtheme.cssBreakpoints.small]: {
            justifyContent: 'center',
        },
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    heading: {
        [newtheme.cssBreakpoints.large]: {
            fontSize: 38,
            marginRight: 50,
        },
        [newtheme.cssBreakpoints.medium]: {
            fontSize: 25,
        },
        [newtheme.cssBreakpoints.small]: {
            fontSize: 24,
            textAlign: 'center',
            margin: 0,
            marginBottom: 30,
        },
        [newtheme.cssBreakpoints.tiny]: {
            fontSize: 22,
        },
        fontSize: 48,
        fontWeight: 500,
        flex: 1,
        marginRight: 70,
    },
    mainButton: {
        [newtheme.cssBreakpoints.large]: {
            padding: '15px 30px',
        },
        [newtheme.cssBreakpoints.small]: {
            padding: '10px 20px',
            fontSize: 14,
            borderRadius: 10,
        },
        [newtheme.cssBreakpoints.tiny]: {},
        ':hover': {
            backgroundColor: 'white',
            color: 'black',
            stroke: 'black',
        },
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: newtheme.colors.primaryBlue,
        color: 'white',
        stroke: 'white',
        border: 'none',
        borderRadius: 15,
        fontSize: 18,
        fontWeight: 500,
        padding: '20px 40px',
    },
    arrowIcon: {
        color: 'white',
        height: 31,
        width: 33,
        marginLeft: 10,
    },
});

function mapStateToProps(state: IState): IPropsFromState {
    return {
        user: state.user.user,
        subscriptionProduct: getSelectedSubscriptionProduct(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch): IPropsFromDispatch {
    return bindActionCreators({ openModal }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StartListeningBanner));
